var _rect, _rect2, _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMute = function SvgMute(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 49,
    viewBox: "0 0 48 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 47,
    height: 47,
    rx: 7.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 1,
    width: 47,
    height: 47,
    rx: 7.5,
    stroke: "#5547DD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 14.5C22.8949 14.5 21.8351 14.939 21.0537 15.7204C20.2723 16.5018 19.8333 17.5616 19.8333 18.6667V24.5C19.8333 25.6051 20.2723 26.6649 21.0537 27.4463C21.8351 28.2277 22.8949 28.6667 24 28.6667C25.1051 28.6667 26.1649 28.2277 26.9463 27.4463C27.7277 26.6649 28.1667 25.6051 28.1667 24.5V18.6667C28.1667 17.5616 27.7277 16.5018 26.9463 15.7204C26.1649 14.939 25.1051 14.5 24 14.5ZM17.3333 23.6667C17.5543 23.6667 17.7663 23.7545 17.9226 23.9107C18.0789 24.067 18.1667 24.279 18.1667 24.5C18.1667 26.0471 18.7812 27.5308 19.8752 28.6248C20.9692 29.7188 22.4529 30.3333 24 30.3333C25.5471 30.3333 27.0308 29.7188 28.1248 28.6248C29.2188 27.5308 29.8333 26.0471 29.8333 24.5C29.8333 24.279 29.9211 24.067 30.0774 23.9107C30.2337 23.7545 30.4457 23.6667 30.6667 23.6667C30.8877 23.6667 31.0996 23.7545 31.2559 23.9107C31.4122 24.067 31.5 24.279 31.5 24.5C31.5004 26.3451 30.8206 28.1255 29.5906 29.5009C28.3607 30.8763 26.667 31.75 24.8333 31.955V33.6667C24.8333 33.8877 24.7455 34.0996 24.5893 34.2559C24.433 34.4122 24.221 34.5 24 34.5C23.779 34.5 23.567 34.4122 23.4107 34.2559C23.2545 34.0996 23.1667 33.8877 23.1667 33.6667V31.955C21.333 31.75 19.6393 30.8763 18.4093 29.5009C17.1794 28.1255 16.4996 26.3451 16.5 24.5C16.5 24.279 16.5878 24.067 16.7441 23.9107C16.9004 23.7545 17.1123 23.6667 17.3333 23.6667Z",
    fill: "#5547DD"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMute);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "Mute.35f61bee9af170568508607f13766872.svg";